import { motion } from 'framer-motion';
import SectionHeading from '../../../components/ui/SectionHeading';
import {
  AcademicCapIcon,
  UserGroupIcon,
  GlobeEuropeAfricaIcon,
  BriefcaseIcon
} from '@heroicons/react/24/outline';

interface Feature {
  name: string;
  description: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const features: Feature[] = [
  {
    name: 'Excellence académique',
    description: 'Un programme éducatif rigoureux aligné sur les standards internationaux pour préparer nos élèves à réussir.',
    icon: AcademicCapIcon,
  },
  {
    name: 'Enseignement multilingue',
    description: 'Formation en arabe, français et anglais pour préparer les élèves à un avenir international.',
    icon: GlobeEuropeAfricaIcon,
  },
  {
    name: 'Cadre éducatif stimulant',
    description: "Des installations modernes et un environnement sécurisé favorisant l'apprentissage et l'épanouissement.",
    icon: BriefcaseIcon,
  },
  {
    name: 'Accompagnement personnalisé',
    description: 'Une attention individuelle pour chaque élève avec un suivi régulier et des communications avec les parents.',
    icon: UserGroupIcon,
  },
];

const FeaturesSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  };

  return (
    <div className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <SectionHeading
          title="Pourquoi choisir le Groupe Scolaire Sanaa ?"
          subtitle="Nos points forts"
          centered={true}
        />

        <motion.div
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {features.map((feature) => (
            <motion.div
              key={feature.name}
              className="flex flex-col items-center text-center p-6 rounded-lg border border-gray-100 shadow-elegant bg-white hover:shadow-elegant-lg hover:border-primary/20 transition-all duration-300"
              variants={itemVariants}
            >
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <feature.icon className="h-8 w-8 text-primary" />
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-900">{feature.name}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FeaturesSection;
